// ════════════════════════════════════════════════════════════════════════
//  AVISO GENERAL — el banner que pone un admin (Panel de control → Avisos)
//
//  Pastilla abajo al centro, encima de todo, en todas las páginas (también en
//  la de entrar: "esta noche hay mantenimiento" lo tiene que ver quien aún no
//  entró). Se pide a GET /auth/announcement al cargar y cada 5 min.
//
//  ✕ lo cierra para ESTE aviso: se recuerda su id en localStorage. Si el admin
//  publica otro (id nuevo), vuelve a salir.
// ════════════════════════════════════════════════════════════════════════
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API from '../api';
import { getLang, useLang, useT } from '../i18n';
import './AnnouncementBanner.css';

const CERRADO_KEY = 'dragonAvisoCerrado';
const CADA_MS = 5 * 60 * 1000;

const cerradoId = () => {
  try { return Number(localStorage.getItem(CERRADO_KEY)) || 0; } catch (_) { return 0; }
};

export default function AnnouncementBanner() {
  const t = useT();
  useLang();
  const [aviso, setAviso] = useState(null);
  const [cerrado, setCerrado] = useState(cerradoId);

  useEffect(() => {
    let vivo = true;
    const pedir = () => axios.get(`${API}/auth/announcement`)
      .then((r) => { if (vivo && r.data && typeof r.data === 'object') setAviso(r.data.aviso || null); })
      .catch(() => { /* sin aviso no pasa nada: la app sigue */ });
    pedir();
    const id = setInterval(pedir, CADA_MS);
    return () => { vivo = false; clearInterval(id); };
  }, []);

  if (!aviso || aviso.id === cerrado) return null;
  const texto = getLang() === 'es' ? aviso.texto_es || aviso.texto_en : aviso.texto_en || aviso.texto_es;
  if (!texto) return null;
  const cerrar = () => {
    try { localStorage.setItem(CERRADO_KEY, String(aviso.id)); } catch (_) { /* modo privado */ }
    setCerrado(aviso.id);
  };

  return (
    <div className={`aviso-banner aviso-banner--${aviso.tono}`} role="status">
      <span className="aviso-banner-ico" aria-hidden="true">{aviso.tono === 'mantenimiento' ? '⚙' : aviso.tono === 'aviso' ? '!' : 'i'}</span>
      <span>{texto}</span>
      <button type="button" className="aviso-banner-x" onClick={cerrar} aria-label={t('admin.ann.close')}>×</button>
    </div>
  );
}
